import React from 'react';
import { useHistory } from 'react-router-dom';
import styles from './Skill.module.scss';
import Actions from '../actions/Actions';
import ContentAudio from '../../../../components/content-audio/ContentAudio';
import Button from '../../../../components/button/Button';

type Props = {
  data: string;
  description?: string | null;
  isFullScreen: boolean;
};

function Audio(props: Props) {
  const { data, description, isFullScreen } = props;
  const {push} = useHistory();
  const onGoToPADashboard = () => {
    push('/parent/dashboard');
  }

  return (
    <Actions fullScreen={isFullScreen} rightButton={<Button size={'extraSmall'} onClick={onGoToPADashboard} label={'GO TO DASHBOARD'} className={styles.paGoTo} />}>
      <div className={styles.description}>
        {description || ''}
      </div>
      <div className={styles.content}>
        <ContentAudio data={data}/>
      </div>
    </Actions>
  );
}

export default Audio;
